export function getOnchainHoldersStateId(memeId: string) {
  return `onchain-holders-${memeId}`;
}
